import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49aa0aa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table",
  border: "1",
  cellpadding: "5",
  style: {"border-collapse":"collapse","border":"1px solid black","caption-side":"top","margin-right":"5px"},
  "data-excelautofilter": "",
  "data-excelautofilter-row-skip": "1"
}
const _hoisted_2 = { class: "sticky" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["bgcolor"]
const _hoisted_7 = ["bgcolor", "onClick", "innerHTML"]

import { computed, ref, watch } from 'vue';

import OilPressureFilterPopup from './Popup/OilPressureFilterPopup.vue';

import type { FilterName, SortName } from './Popup/OilPressureFilterPopup.vue';
import type {
  DayPressure,
  DetailPressure,
  ObjectPressure,
} from '@/Template/OilPressure/OilPressure';
import type { OilPressure, EnginePressure } from '@/types/Pressure';
import {
  ENGINE_OIL_TEMP_FORMAT_TYPES,
  type Column,
  type FORMAT_TYPE,
  ENGINE_OIL_TEMP_FORMAT_TYPE,
  SUMMARY_FORMAT_TYPES,
} from './Columns';

export type Value = string | number;

export type Filters = { [ColChildName: string]: Filter };
export type Filter = {
  isActive: boolean;
  isNumberFilter: boolean;
  title: string;
  selectedValues: Value[];
  selectedFilter: FilterName;
  selectedSorting: SortName;
  values: Value[];
};

export type Cell = {
  colName?: string;
  childName?: string;
  classNames?: string[];
  style?: string;
  bgcolor?: string;
  bodyAttrs?: { [key: string]: string };
  headAttrs?: { [key: string]: string };
  value?: string | number;
  clickHandler?: () => void;
};

export type Row = {
  rowBackgroundColor: string;
  cells: Cell[];
};

export type Props = {
  columns: Column[];
  objects: ObjectPressure[];
  handler: (obj: ObjectPressure) => DayPressure[] | DetailPressure[];
  pressureKey: 'e' | 'o';
  formatTypes: FORMAT_TYPE[];
  handleFilters?: boolean;
  filters?: Filters;
  templateName?: string;
  onRowClick?: (obj: ObjectPressure) => void;
};

export type Emit = {
  (
    e: 'onRowClick',
    obj: ObjectPressure,
    row: DayPressure | DetailPressure,
    motoKey: number,
    temperatureKey: number,
    pressureKey: string,
    filters?: Filters,
  ): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PressureTable',
  props: {
    columns: null,
    objects: null,
    handler: null,
    pressureKey: null,
    formatTypes: null,
    handleFilters: { type: Boolean },
    filters: null,
    templateName: null,
    onRowClick: null
  },
  emits: ["onRowClick"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'onRowClick',
    obj: ObjectPressure,
    row: DayPressure | DetailPressure,
    motoKey: number,
    temperatureKey: number,
    pressureKey: string,
    filters?: Filters,
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  columns: Column[];
  objects: ObjectPressure[];
  handler: (obj: ObjectPressure) => DayPressure[] | DetailPressure[];
  pressureKey: 'e' | 'o';
  formatTypes: FORMAT_TYPE[];
  handleFilters?: boolean;
  filters?: Filters;
  templateName?: string;
  onRowClick?: (obj: ObjectPressure) => void;
}




const FILTER_KEY_SEPARATOR = '#';
const BG_COLOR = {
  LightGrey: '#f5f5f5',
  DarkGrey: '#eeeeee',
};

const showFilterPopup = ref(false);
const filters = ref<Filters>({});
const clickedColumnFilterKey = ref<keyof Filters>('');

const rows = ref<Row[]>([]);

watch(
  () => props.objects,
  () => {
    if (props.filters) {
      filters.value = { ...props.filters };
    }

    filterRows();
  },
  {
    immediate: true,
    deep: true,
  },
);

function isDataEmpty(obj: any) {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return true;
  }

  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch (e) {
      // Некорректный JSON — считаем пустым
      return true;
    }
  }

  return Object.keys(obj).length === 0;
}

function getVal(data: any, col: any, child: any, type: string) {
  let isEmptyValues = false;
  if (props.templateName === 'oilPressure') {
    
  } else if (props.templateName === 'engineOilTemp') {
    isEmptyValues = isDataEmpty(data['engoiltmprs']);
  } else if (props.templateName === 'retarderOilTemp') {
    isEmptyValues = isDataEmpty(data['retarderoiltmprs']);
  }

  if (!data) return 'н/д';
  if (SUMMARY_FORMAT_TYPES.includes(type as FORMAT_TYPE)) {
    const pressureParam = type.startsWith('period-')
      ? 'minPerPeriod'
      : 'pressure';
    return child.format(
      data[pressureParam]?.[props.pressureKey]?.[col.name]?.[child.name],
      type,
      undefined,
      isEmptyValues
    );
  }
  if (
    ENGINE_OIL_TEMP_FORMAT_TYPES.includes(type as ENGINE_OIL_TEMP_FORMAT_TYPE)
  ) {
    if (col.name === 'info') {
      return child.format(data[child.name], type, data.engine_time, isEmptyValues);
    } else {
      return child.format(data[col.name]?.[child.name], type, data.engine_time, isEmptyValues);
    }
  }
}

function getTHBgColor(index: number) {
  return index % 2 === 1 ? BG_COLOR.LightGrey : '';
}

function getTDBgColor(colIndex: number, index: number) {
  if (colIndex % 2 === 1) {
    return index % 2 === 1 ? BG_COLOR.DarkGrey : BG_COLOR.LightGrey;
  } else {
    return index % 2 === 1 ? BG_COLOR.LightGrey : undefined;
  }
}

function getClassNames({
  row,
  col,
  child,
  childIndex,
  type,
}: {
  row: any;
  col: any;
  child: any;
  childIndex: number;
  type: any;
}) {
  if (col.name === 'info') {
    return type === 'min' ? ['border-top'] : [];
  }
  const classNames: string[] = [];
  if (type === 'min') {
    classNames.push('border-top');

    if (getVal(row, col, child, type) < 1.2) {
      classNames.push('bg-yellow-3');
    }
    if (getVal(row, col, child, type) < 1) {
      classNames.push('bg-red-3');
    }
  }
  if (childIndex === 0) {
    classNames.push('border-left');
  }
  if (!!col.banner) {
    classNames.push('cursor-pointer');
  }
  return classNames;
}

function onSaveFilter(
  data: {
    selectedValues: Value[];
    selectedFilter: Filter['selectedFilter'];
    selectedSorting: Filter['selectedSorting'];
  } = { selectedValues: [], selectedFilter: 'none', selectedSorting: 'none' },
) {
  showFilterPopup.value = false;

  const key = clickedColumnFilterKey.value;

  const filter = filters.value[key];

  filter.selectedValues = data.selectedValues;
  filter.selectedFilter = data.selectedFilter;
  filter.selectedSorting = data.selectedSorting;

  filterRows();
  sortRows();

  for (const key in filters.value) {
    const currentFilter = filters.value[key];
    if (
      currentFilter.selectedValues.length === currentFilter.values.length &&
      currentFilter.selectedFilter === 'none' &&
      currentFilter.selectedSorting === 'none'
    ) {
      currentFilter.isActive = false;
      delete filters.value[key];
    } else {
      currentFilter.isActive = true;
    }
  }
}

function filterRows() {
  const newRows: Row[] = [];

  props.objects.forEach((object, index: number) => {
    props.handler(object).forEach((row, rowIndex: number) => {
      props.formatTypes.forEach((type) => {
        let isShow = false;
        const newRow: Row = {
          rowBackgroundColor: getTHBgColor(index),
          cells: [],
        };
        props.columns.forEach((col, colIndex: number) => {
          if (!col.children) return;

          col.children.forEach((child, childIndex: number) => {
            const cell: Cell = {
              colName: col.name,
              childName: child.name,
            };

            if (child.bodyAttrs && typeof child.bodyAttrs === 'function') {
              if (child.name === 'engineMoto') {
                cell.bodyAttrs = child.bodyAttrs(
                  child.format?.(row, type, row.engine_time) || '',
                  col,
                  child,
                  type,
                );
              } else {
                cell.bodyAttrs = child.bodyAttrs(getVal(row, col, child, type));
              }
            } else {
              cell.bodyAttrs = child.bodyAttrs;
            }
            cell.classNames = getClassNames({
              row,
              col,
              child,
              type,
              childIndex,
            });

            if (col.name === 'info') {
              if (child.name === 'engineMoto') {
                cell.value = child.format?.(row, type, row.engine_time);
              } else {
                cell.value = child.format?.(object, type, row);
              }
            } else {
              cell.style = `backgroundColor: ${getTDBgColor(colIndex, index)}`;
              cell.bgcolor = getTDBgColor(colIndex, index);
              cell.value = getVal(row, col, child, type);

              cell.clickHandler = () => {
                emit(
                  'onRowClick',
                  object,
                  row,
                  colIndex,
                  childIndex,
                  props.pressureKey,
                  filters.value,
                );
              };
            }

            newRow.cells.push(cell);

            if (Object.keys(filters.value).length === 0) {
              isShow = true;
              return;
            }

            for (const key in filters.value) {
              const filter = filters.value[key];

              if (filter.selectedValues.length > 0) {
                const [colName, childName] = key.split(FILTER_KEY_SEPARATOR);

                if (colName !== col.name || childName !== child.name) {
                  continue;
                }

                if (filter.selectedFilter === 'none') {
                  isShow = filter.selectedValues.includes(cell.value as Value);
                  continue;
                }

                if (filter.selectedFilter === 'moreOrEqual') {
                  for (const selectedValues of filter.selectedValues) {
                    if (Number(cell.value) >= Number(selectedValues)) {
                      isShow = true;
                      break;
                    }
                  }
                  if (!isShow) break;
                }

                if (filter.selectedFilter === 'lessOrEqual') {
                  for (const selectedValues of filter.selectedValues) {
                    if (Number(cell.value) <= Number(selectedValues)) {
                      isShow = true;
                      break;
                    }
                  }
                  if (!isShow) break;
                }

                if (filter.selectedFilter === 'between') {
                  let max: any, min: any;

                  for (const selectedValues of filter.selectedValues) {
                    const num = Number(selectedValues);
                    if (num > max || max === undefined) max = num;
                    if (num < min || min === undefined) min = num;
                  }

                  if (Number(cell.value) >= min && Number(cell.value) <= max) {
                    isShow = true;
                  }

                  if (!isShow) break;
                }
              } else {
                isShow = false;
              }
            }
          });
        });

        if (isShow) {
          newRows.push(newRow);
          rowIndex++;
        }
      });
    });
  });

  rows.value = newRows;
}

function sortRows() {
  for (const key in filters.value) {
    const filter = filters.value[key];

    if (filter.selectedSorting === 'none') {
      continue;
    }

    const [_, childName] = key.split(FILTER_KEY_SEPARATOR);

    if (filter.selectedSorting === 'asc') {
      rows.value.sort((a, b) => {
        const A = a.cells.find((cell) => cell.childName === childName);
        const B = b.cells.find((cell) => cell.childName === childName);
        return Number(A?.value) - Number(B?.value);
      });
      continue;
    }

    if (filter.selectedSorting === 'desc') {
      rows.value.sort((a, b) => {
        const A = a.cells.find((cell) => cell.childName === childName);
        const B = b.cells.find((cell) => cell.childName === childName);
        return Number(B?.value) - Number(A?.value);
      });
      continue;
    }
  }
}

function displayFilterPopup(label: string, colName: string, childName: string) {
  if (!props.handleFilters) {
    return;
  }
  const values = new Set<string>();

  const key = colName + FILTER_KEY_SEPARATOR + childName;
  const currentFilter = filters.value[key];

  if (!currentFilter) {
    props.objects.forEach((object: any) => {
      props.handler(object).forEach((row: any) => {
        props.formatTypes.forEach((type: string) => {
          props.columns.forEach((col: any) => {
            if (col.name === colName) {
              col.children.forEach((child: any) => {
                if (child.name === childName) {
                  if (col.name === 'info') {
                    values.add(child.format(object, type, row));
                  } else {
                    values.add(getVal(row, col, child, type));
                  }
                }
              });
            }
          });
        });
      });
    });

    filters.value[key] = {
      isActive: false,
      isNumberFilter: colName !== 'info' || childName === 'can_moto',
      selectedValues: [...values],
      selectedFilter: 'none',
      values: [...values],
      title: label,
      selectedSorting: 'none',
    };
  }

  clickedColumnFilterKey.value = key;

  showFilterPopup.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col, index) => {
            return (_openBlock(), _createElementBlock("th", _mergeProps({ key: index }, col.headAttrs, {
              innerHTML: col.label
            }), null, 16, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.children, (child, childIndex) => {
                return (_openBlock(), _createElementBlock("th", _mergeProps({ key: childIndex }, child.headAttrs, {
                  class: props.handleFilters ? 'pointer' : 'px-2 py-1',
                  onClick: ($event: any) => (displayFilterPopup(child.label, col.name, child.name))
                }), [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                props.handleFilters && 'filter-icon-overflow',
                filters.value[col.name + FILTER_KEY_SEPARATOR + child.name]
                  ?.isActive && 'filter-icon-overflow--active-icon',
              ]),
                    innerHTML: child.label
                  }, null, 10, _hoisted_5)
                ], 16, _hoisted_4))
              }), 128))
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowIndex,
            style: _normalizeStyle({ backgroundColor: row.rowBackgroundColor }),
            bgcolor: row.rowBackgroundColor
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, (cell, cellIndex) => {
              return (_openBlock(), _createElementBlock("td", _mergeProps({ key: cellIndex }, cell.bodyAttrs, {
                class: cell.classNames,
                style: cell.style,
                bgcolor: cell.bgcolor,
                onClick: cell.clickHandler,
                innerHTML: cell.value
              }), null, 16, _hoisted_7))
            }), 128))
          ], 12, _hoisted_6))
        }), 128))
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (clickedColumnFilterKey.value && showFilterPopup.value)
        ? (_openBlock(), _createBlock(OilPressureFilterPopup, {
            key: 0,
            title: filters.value[clickedColumnFilterKey.value || '']?.title,
            numberFilter: filters.value[clickedColumnFilterKey.value || '']?.isNumberFilter,
            selected: filters.value[clickedColumnFilterKey.value || '']?.selectedValues,
            filter: filters.value[clickedColumnFilterKey.value || '']?.selectedFilter,
            sorting: filters.value[clickedColumnFilterKey.value || '']?.selectedSorting,
            options: filters.value[clickedColumnFilterKey.value || '']?.values,
            "disabled-options": [],
            onSave: onSaveFilter,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (showFilterPopup.value = false))
          }, null, 8, ["title", "numberFilter", "selected", "filter", "sorting", "options"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})